import React from 'react'

import { COMPONENT_EXTENDER } from 'extender'

const SingleContainerLayout = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')
const ServicePlans = COMPONENT_EXTENDER('components/core/Settings/ServicePlans/ServicePlans-component')

const ServicePlansPage = () => (
    <SingleContainerLayout servicePlansPage>
        <ServicePlans />
    </SingleContainerLayout>
)

export default ServicePlansPage
